import { BTC, BITCOIN_CONVERSION_NUM, SATOSHI_CONVERSION_NUM } from '../constants'

export const formatAmountAsPerTheCoinUnit = (coinUnit, amount) => {
  if(coinUnit == BTC) {
    return (parseFloat(amount)).toFixed(BITCOIN_CONVERSION_NUM)
  }
  else {
    return (amount * SATOSHI_CONVERSION_NUM).toLocaleString()
  }
}

export const calcAmountNumberAsPerCoinUnit = (coinUnit, amount) => {
  if(coinUnit == BTC) {
    return Number(amount.toFixed(BITCOIN_CONVERSION_NUM))
  } else {
    return Number((amount * SATOSHI_CONVERSION_NUM))
  }
}
